<template>
  <section-container>
    <header-page
      :title_header="
        !this.$route.params.id ? 'Novo cliente' : 'Atualizar cliente'
      "
      :sub_header="
        !this.$route.params.id
          ? 'Adicione um novo cliente'
          : 'Atualize o cliente cadastrado'
      "
    />
    <content-e>
      <div class="w-full rounded-lg bg-white shadow-2l">
        <div class="bg-white shadow-2l rounded p-6">
          <h2
            class="
              text-md
              font-bold
              mb-4
              pb-4
              border-b border-dashed
              block
              w-full
            "
          >
            Informações da Principais
          </h2>
          <form
            action=""
            class="flex flex-wrap w-full"
            ref="formCategories"
            @submit.prevent="doStoreCustomer"
          >
            <div class="w-full p-2 flex flex-wrap">
              <div class="w-full md:w-1/2 p-2">
                <input-icon
                  :icon="{ name: 'user', type: 'solid' }"
                  id="name"
                  name="name"
                  type="text"
                  v-model="name"
                  label="Nome completo:"
                ></input-icon>
              </div>
              <div class="w-full md:w-1/2 p-2">
                <input-icon
                  :icon="{ name: 'envelope', type: 'solid' }"
                  id="name"
                  name="name"
                  type="text"
                  v-model="email"
                  label="E-mail:"
                ></input-icon>
              </div>
              <div class="w-full md:w-1/2 p-2">
                <input-icon
                  :icon="{ name: 'phone', type: 'solid' }"
                  id="name"
                  name="name"
                  type="text"
                  v-model="phone"
                  v-mask="['(##) #####-####']"
                  label="Telefone:"
                ></input-icon>
              </div>
              <h2
                class="
                  text-md
                  font-bold
                  mb-4
                  pb-4
                  border-b border-dashed
                  block
                  w-full
                "
              >
                Endereço
              </h2>
              <div class="w-full md:w-1/2 flex flex-wrap">
                <div class="w-full p-2">
                  <input-icon
                    :icon="{ name: 'map' }"
                    id="address_zipcode"
                    name="address[zipcode]"
                    type="text"
                    v-mask="'#####-###'"
                    v-model="zipcode"
                    max="9"
                    label="Cep:"
                  ></input-icon>
                  <small
                    >Informe o cep do endereço atual para preenchimento
                  </small>
                </div>
              </div>
              <div
                v-if="address_card"
                class="w-full rounded border-b-4 border-indigo-500"
              >
                <div class="flex flex-wrap">
                  <div
                    class="
                      w-full
                      md:w-12/12
                      md:mb-0
                      p-4
                      md:p-4
                      border-2 border-b-0 border-gray-200
                    "
                  >
                    <h3 class="text-md font-bold">Endereço</h3>
                    <p class="text-lg my-5">
                      Rua: {{ address.street }},
                      <span v-if="address.number" class="font-bold"
                        >N°{{ address.number }}</span
                      >
                      <span v-if="address.complement" class="font-bold">
                        Complemento: {{ address.complement }}</span
                      >
                      <br />
                      Bairro: {{ address.neighborhood }}, Cidade:
                      {{ address.city }} - {{ address.uf }}
                    </p>
                  </div>

                  <div class="w-full md:w-5/12 md:mb-0 p-4 md:p-4 bg-gray-200">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input-icon
                        :icon="{ name: 'map' }"
                        id="address_number"
                        name="address_number"
                        type="text"
                        v-model="address.number"
                        label="Numero:"
                      ></input-icon>
                      <span
                        class="text-red-500 block pt-1"
                        v-if="errors.length"
                      >
                        <i class="bx bx-error mr-1"></i>
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                  <div
                    class="
                      w-full
                      md:w-7/12
                      md:mb-0
                      p-0
                      px-4
                      py-2
                      md:p-4
                      bg-gray-200
                    "
                  >
                    <input-icon
                      :icon="{ name: 'map' }"
                      id="address_complement"
                      name="address_complement"
                      type="text"
                      v-model="address.complement"
                      label="Complemento:"
                    ></input-icon>
                    <small class="text-gray-600 text-xs"
                      >Ex: BLOCO 3 AP 42</small
                    >
                  </div>
                </div>
              </div>
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'info-square', type: 'solid' }"
                  id="observation"
                  name="observation"
                  type="text"
                  v-model="observation"
                  label="Observação:"
                ></input-icon>
              </div>
              <div class="w-full p-2 my-5 border-t border-dashed pt-6">
                <button-icon
                  icon="plus"
                  :text="
                    this.$route.params.id
                      ? `Atualizar Cliente`
                      : `Adicionar Cliente`
                  "
                  class="bg-indigo-600"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </content-e>
  </section-container>
</template>

<script>
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
extend('email', email)

// Override the default message.
extend('required', {
  ...required,
  message: 'Esse campo é obrigatório'
})

extend('email', {
  ...email,
  message: 'Endereço de e-mail não é valido'
})
export default {
  data() {
    return {
      name: null,
      email: null,
      phone: null,
      zipcode: null,
      address: {},
      address_card: false,
      observation: null
    }
  },
  watch: {
    zipcode() {
      if (this.loading_cep) {
        return
      }
      if (this.zipcode.length === 9) {
        this.doAddress()
      } else {
        this.address_card = false
      }
    }
  },
  methods: {
    async doLoadCustomerById() {
      const customer = await this.$store.dispatch(
        'store/GET_CUSTOMER_BY_ID',
        this.$route.params.id
      )

      this.name = customer.data.name
      this.email = customer.data.email
      this.phone = customer.data.phone
      this.observation = customer.data.observation
      this.address = customer.data.address
      this.address_card = true
      this.loading_cep = false
    },
    doAddress(e) {
      this.$store
        .dispatch('util/getAddressByCep', this.zipcode)
        .then((response) => {
          const address = response.data
          this.address = {
            zipcode: address.data.cep,
            street: address.data.logradouro,
            complement: address.data.complemento,
            neighborhood: address.data.bairro,
            city: address.data.localidade,
            uf: address.data.uf,
            ddd: address.data.ddd
          }
          this.address_card = !this.address_card
        })
    },
    doStoreCustomer() {
      const data = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        address: this.address,
        observation: this.observation
      }

      if (this.$route.params.id) {
        data.id = this.$route.params.id
      }
      this.$store
        .dispatch(
          this.$route.params.id
            ? 'store/UPDATE_CUSTOMER'
            : 'store/STORE_CUSTOMER',
          data
        )
        .then((response) => {
          this.$toasted.success(response.data.message, {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
          this.$router.push({
            name: 'customers.index'
          })
        })
        .catch((error) => {
          const msg = Object.values(error.data.errors)
          msg.forEach((item, i) => {
            this.$toasted.error(item, {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          })
        })
    }
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.doLoadCustomerById()
    }
  }
}
</script>

<style>
</style>
